import { Component } from '@angular/core';

import { take, takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SingleDetailComponent } from 'app/shared/components/single-detail/single-detail.component';
import { IInboundDetailsModel } from 'app/shared/models/inbound.models';
import { LogisticsInboundService } from 'app/shared/services/inbound.service';

import { ScannedDetailsComponentBase } from '../ScannedDetailsComponentBase';

@Component({
  selector: 'app-scanned-inbound-receipt-details',
  templateUrl: './scanned-inbound-receipt-details.component.html',
  styleUrls: ['./scanned-inbound-receipt-details.component.css'],
  standalone: true,
  imports: [SingleDetailComponent],
})
export class ScannedInboundReceiptDetailsComponent extends ScannedDetailsComponentBase {
  public inboundDetailsModel: IInboundDetailsModel;

  constructor(private inboundServices: LogisticsInboundService) {
    super();
  }

  handleCodeScanned(): void {
    this.inboundServices
      .getInboundDetailsByLabelCodeV1(this.labelCode.identifier)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (inboundDetailsModel: IInboundDetailsModel) => {
          this.inboundDetailsModel = inboundDetailsModel;
          this.navigationInstructions.emit([`/logistics/inbound`, inboundDetailsModel.id]);
        },
        error: (_error) => this.handleScanFail(),
      });
  }
}
